import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useSubmitQuizMutation } from "../../features/quizzes/quizzesApi";
import { totalCorrectQuizzes } from "../../utils/totalCorrectQuizzes";
import Error from "../ui/Error";
import QuizQuestion from "./QuizQuestion";

export default function QuizQuestions({ quizzes, video }) {
  const [submitError, setSubmitError] = useState();
  const navigate = useNavigate();
  const [submitQuiz, { isSuccess, isError, isLoading, error }] =
    useSubmitQuizMutation();
  const user = useSelector((state) => state.auth.user);

  const [selectedOptions, setSelectedOptions] = useState([]);

  const handleOptionSelected = (quizId, optionId) => {
    const quizIndex = selectedOptions.findIndex(
      (selectedOption) => selectedOption.quizId === quizId
    );

    if (quizIndex !== -1) {
      // if quiz exist in the state then update it
      const isOptionExist =
        selectedOptions[quizIndex].selectedOptionsId.indexOf(optionId);
      if (isOptionExist !== -1) {
        // if option exist then remove it
        setSelectedOptions((prevSelectedOptions) => {
          return prevSelectedOptions.map((option, index) => {
            if (index === quizIndex) {
              const selectedOptionsId = option.selectedOptionsId.filter(
                (id) => id !== optionId
              );
              return {
                ...option,
                selectedOptionsId,
              };
            }
            return option;
          });
        });
      } else {
        // if option dont exist then add it
        setSelectedOptions((prevSelectedOptions) => {
          return prevSelectedOptions.map((option, index) => {
            if (index === quizIndex) {
              return {
                ...option,
                selectedOptionsId: [...option.selectedOptionsId, optionId],
              };
            }
            return option;
          });
        });
      }
    } else {
      // if quiz don't exist in the state then create new
      setSelectedOptions([
        ...selectedOptions,
        {
          quizId,
          selectedOptionsId: [optionId],
        },
      ]);
    }
  };

  const handleQuizSubmit = () => {
    const totalQuiz = quizzes.length;
    const totalCorrectQuiz = totalCorrectQuizzes(quizzes, selectedOptions);
    const data = {
      student_id: user?.id,
      student_name: user?.name,
      video_id: video.id,
      video_title: video?.title,
      totalQuiz,
      totalCorrect: totalCorrectQuiz,
      totalWrong: totalQuiz - totalCorrectQuiz,
      totalMark: totalQuiz * process.env.REACT_APP_EACH_QUIZ_MARK,
      mark: totalCorrectQuiz * process.env.REACT_APP_EACH_QUIZ_MARK,
    };
    submitQuiz(data);
  };

  useEffect(() => {
    if (isSuccess) {
      navigate("/leaderBoard");
    }
    if (isError) {
      setSubmitError(error.message);
    }
  }, [isSuccess, navigate, isError, setSubmitError, error]);

  return (
    <>
      <div className="space-y-8 ">
        {quizzes?.map((quiz) => (
          <QuizQuestion
            handleOptionSelected={handleOptionSelected}
            key={quiz.id}
            quiz={quiz}
          />
        ))}
      </div>
      <button
        disabled={isLoading}
        onClick={handleQuizSubmit}
        className="px-4 py-2 rounded-full bg-cyan block ml-auto mt-8 hover:opacity-90 active:opacity-100 active:scale-95 "
      >
        Submit
      </button>
      {submitError && <Error message={submitError} />}
    </>
  );
}
